module.exports = __webpack_public_path__ + "static/img/coreTechnology_2.61dfe32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_2.jpg
// module id = kkKK
// module chunks = 0